import http from '../http';

export interface Answer {
  text: string;
  correct: boolean;
}

export type QuizDifficulty = 'EASY' | 'MEDIUM' | 'HARD';

export interface Quiz {
  id: string;
  questionText: string;
  answers: Answer[];
  difficulty: QuizDifficulty;
  category: string;
  reason: string;
}

export interface UserQuizAnswer {
  userName: string;
  userId: string;
  selectedOptionIndex: number;
  correct: boolean;
  quiz: Quiz;
}

export interface LastQuiz {
  quiz: Quiz;
  answers: UserQuizAnswer[];
}

export interface QuizAnswerPayload {
  userId: string;
  questionId: string;
  answerIndex: number;
  time: number;
}

export interface RankingContent {
  position: number;
  userId: string;
  userName: string;
  companyName: string;
  correctCount: number;
  points: number;
}

type RankingResponse = {
  content: RankingContent[];
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  first: boolean;
  empty: boolean;
};

export const quiz = {
  getQuizOfTheDay: async (id: string) => {
    const { data, status } = await http.get<Quiz>(`/v3/kds/quiz/today/${id}`);
    if (status !== 200) {
      throw new Error((data as any).message);
    }
    return data;
  },
  getQuizOfYesterday: async () => {
    const { data, status } = await http.get<LastQuiz>('/v3/kds/quiz/yesterday');
    if (status !== 200) {
      throw new Error((data as any).message);
    }
    return data;
  },
  answerQuiz: async (data: QuizAnswerPayload) => {
    const { status, data: result } = await http.post('v3/kds/quiz/answer', data);

    if (status !== 200) {
      throw new Error((result as any).message);
    }
    return result;
  },
  answered: async (id: string) => {
    const { data, status } = await http.get<{
      answered: boolean;
    }>(`/v3/kds/quiz/answered/today?userId=${id}`);

    if (status !== 200) {
      throw new Error((data as any).message);
    }

    return data;
  },
  ranking: async ({ queryKey }: { queryKey: any }) => {
    const [, { company, page, startDate, endDate }] = queryKey;

    const params = new URLSearchParams({
      startDate,
      endDate,
      page: page.toString(),
      size: '10',
    });

    if (company !== undefined) {
      params.append('company', company.toString());
    }

    const { status, data: result } = await http.get<RankingResponse>(
      `/v3/kds/quiz/list/ranking?${params.toString()}`,
    );

    if (status !== 200) {
      throw new Error((result as any).message);
    }

    return result;
  },
};
